<div class="widget-inner-alert_wrapper">

    <div class="widget-inner-alert_title">
        {{title | l10n}}
    </div>

    <div class="widget-inner-alert_body">
        {{'components.widgets.trade-widget.max_quantity_error_message' | l10n:messageTranslationParams}}
        <span class="order-max-quantity-alert_max-quantity">
            <span class="order-max-quantity-alert_max-quantity-value {{maxQuantityDisplayDecimal.class}}">{{maxQuantityDisplayDecimal.value}}</span> {{qtyCurrency}}
        </span>
    </div>

    <button type="submit" class="widget-inner-alert_button" (click)="close()">
        {{buttonText | l10n}}
    </button>

    <svg class="widget-inner-alert_close" (click)="close()"><use xlink:href="#close"></use></svg>
</div>
